/*
 * @Author: tony.zhu
 * @Date: 2025-02-07 14:48:06
 * @LastEditTime: 2025-02-08 18:42:26
 * @LastEditors: tony.zhu
 * @Description: 
 */

import VueI18n from 'vue-i18n'
import Vue from 'vue'
import zh from './zh_cn.json'
import en from './package/en_us.json'
import tc from './package/tc_cn.json'
import {
  getCookie,
  setCookie,
} from '@/base/cookie'

//import store from '../vuex/store.js';

var xhr = new XMLHttpRequest();
xhr.withCredentials = true;
xhr.open("GET", process.env.BASE_Marketingforce_Domain + "/api/app/ydyl-converge/lang/getLang", false);
xhr.setRequestHeader("X-Token", getCookie('X-Token'));
xhr.send(null);
if (xhr.status === 200) {
  var res = JSON.parse(xhr.response);
  if(res.code === 200 && res.data){
    console.log('xhrxhr--language', res.data);
    let lang = 'zh'
    if(res.data === 'zh-CN'){
      lang = 'zh'
    }else if(res.data === 'en'){
      lang = 'en'
    }else if(res.data === 'zh-TW'){
      lang = 'tc'
    }
    setCookie('web_language_wm', lang)
  }
}


Vue.use(VueI18n)
const wmxysWebLanguage = getCookie('web_language_wm') || 'en';

//store.commit('app/SET_wmxysWebLanguage', wmxysWebLanguage)

const i18n = new VueI18n({
  locale: wmxysWebLanguage,
  messages: {
    zh,
    en,
    tc
  },
})

export const loadLanguageAsync = async (lang) => {
  // 创建一个 Promise 来处理语言包加载状态
  return new Promise((resolve, reject) => {
    try {
      // 如果语言包已存在
      if (i18n.messages[lang]) {
        i18n.locale = lang
        localStorage.setItem('language', lang)
        resolve({
          status: 'success',
          message: ''
        })
        return
      }

      import(`./package/${lang}.json`)
        .then(messages => {
          i18n.setLocaleMessage(lang, messages.default)
          i18n.locale = lang
          localStorage.setItem('language', lang)
          if (Object.keys(i18n.messages[lang]).length > 0) {
            resolve({
              status: 'success',
              message: ''
            })
          } else {
            reject(new Error(''))
          }
        })
        .catch(error => {
          console.error('Failed to load language pack:', error)
          reject(error)
        })
    } catch (error) {
      console.error('Failed to load language pack:', error)
      reject(error)
    }
  })
}


export default i18n



// WEBPACK FOOTER //
// ./src/language/index.js